import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import WDepartment from "./WDepartment/WDepartment";
import WagesWorker from "./WagesWorker/WagesWorker";
import WagesWorkerAdv from "./WagesWorkerAdv/WagesWorkerAdv";
import WRates from "./WRates/WRates";

export default function WagesLayout() {
  /*   All States
   ********************************************* */
  const [searchParams, setSearchParams] = useSearchParams();
  const [active, setActive] = useState("worker");

  /*   All Functions
   ********************************************* */

  // function to setSearchParams
  const updateSearchParams = (key, value) => {
    // if value is null, delete the key
    if (value === null) {
      searchParams.delete(key);
    } else {
      searchParams.set(key, value);
    }
    setSearchParams(searchParams);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    // Set active tab based on search params
    const tab = searchParams.get("tab") || "worker";
    setActive(tab);
  }, [searchParams]);
  return (
    <div
      className="px-3 py-2"
      style={{
        marginLeft: 260,
        height: "100vh",
      }}
    >
      <h2 className="mb-2">Wages</h2>
      {/* Nav Tabs */}
      <ul className="nav nav-tabs nav-bordered border-0 d-flex flex-grow-1 mb-3">
        <li className="nav-item">
          <button
            className={
              active === "worker"
                ? `btn btn-primary active bg-primary text-white`
                : "bg-white btn"
            }
            onClick={() => {
              updateSearchParams("tab", "worker");
            }}
          >
            <span className="d-none d-md-block">Worker</span>
          </button>
        </li>
        <li className="nav-item">
          <button
            onClick={() => {
              updateSearchParams("tab", "department");
            }}
            className={
              active === "department"
                ? `btn btn-primary active bg-primary text-white`
                : "bg-white btn"
            }
          >
            <span className="d-none d-md-block">Department</span>
          </button>
        </li>
        <li className="nav-item">
          <button
            onClick={() => {
              updateSearchParams("tab", "worker-advance");
            }}
            className={
              active === "worker-advance"
                ? `btn btn-primary active bg-primary text-white`
                : "bg-white btn"
            }
          >
            <span className="d-none d-md-block">Worker Advance</span>
          </button>
        </li>
        <li className="nav-item">
          <button
            onClick={() => {
              updateSearchParams("tab", "style-rate");
            }}
            className={
              active === "style-rate"
                ? `btn btn-primary active bg-primary text-white`
                : "bg-white btn"
            }
          >
            <span className="d-none d-md-block">Style Rate</span>
          </button>
        </li>
      </ul>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div
              className="card-body"
              style={{
                height: "85vh",
                overflowY: "auto",
              }}
            >
              {/* Tab Content */}
              <div className="tab-content ">
                {active === "worker" && (
                  <div className="tab-pane show active ">
                    <WagesWorker />
                  </div>
                )}
                {active === "department" && (
                  <div className="tab-pane show active ">
                    <WDepartment />
                  </div>
                )}
                {active === "worker-advance" && (
                  <div className="tab-pane show active ">
                    <WagesWorkerAdv />
                  </div>
                )}
                {active === "style-rate" && (
                  <div className="tab-pane show active ">
                    <WRates />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
